const { requestManager } = require('../../requestManager');

const { API_PATH } = require('../../config/config');

class RsvSettingMastaApi {
  /**
   * 予約設定マスタ取得
   * @param {Number} rsvSetId 予約設定ID
   * @return {Promise<Object>} 予約設定マスタ
   */
  getRsvSetting = async (rsvSetId) => {
    const params = { rsvSetId };
    const result = await requestManager.get(`${API_PATH}/masta/rsvSetting/r`, params);
    return result.data;
  };
}

export default new RsvSettingMastaApi();
